import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from '../constants/CommonConstants';
import type { ComponentType } from 'react';
import { withSearchCriteriaOnCarouselProps } from '../organisms/CategoryCardLayered/utils/helper';

export const getCategoryComponent = (
  innerComp: string,
  item: string | undefined
): Promise<{ default: ComponentType<unknown> }> => {
  const componentSpa = item?.split('/')[0];
  const leisureComponentPathMap: Record<string, string> = {
    DynamicPropertyCards: 'DynamicPropertyCards',
    PropertiesList: 'PropertiesList',
    CardCarouselResorts: 'CardCarouselResorts',
    TabComponentContainer: 'TabIconNavigation',
  };

  if (componentSpa === 'mi-aem-awp' && innerComp === 'CardCarouselContainer') {
    return import('../organisms/CategoryAwpCardCarouselContainer').then(module => ({
      default: module['CategoryAwpCardCarouselContainerComponent'] as ComponentType<unknown>,
    }));
  }

  if (componentSpa === 'mi-aem-homepage-spa') {
    return import(`../../../mi-homepage-components/src/organisms/${innerComp}/index`).then(module => ({
      default: module[`${innerComp}`] as ComponentType<unknown>,
    }));
  }

  if (componentSpa === 'mi-aem-leisure-spa') {
    const leisureComponentPath = leisureComponentPathMap[innerComp] || innerComp;
    return import(`../../../mi-leisure-components/src/organisms/${leisureComponentPath}/index`).then(module => ({
      default: module[`${innerComp}`] as ComponentType<unknown>,
    }));
  }

  if (
    componentSpa === 'mi-aem-category-spa' &&
    (innerComp === 'CategoryAccordionContainerEnhanced' || innerComp === 'CategoryAccordion')
  ) {
    return import(`../organisms/CategoryAccordionContainerEnhanced/index`).then(module => ({
      default: module.CategoryAccordionContainerEnhanced as ComponentType<unknown>,
    }));
  }

  // Handle mi-aem-utils components (design system components like OCardStandard, OCardBrowse, etc.)
  if (componentSpa === 'mi-aem-utils') {
    const componentName = innerComp.startsWith('O') ? innerComp : `O${innerComp}`;
    return import(`../../../mi-designsystem-components/src/organisms/${componentName}/index`).then(module => ({
      default: module[componentName] as ComponentType<unknown>,
    }));
  }

  return import(`../../../mi-common-static-components/src/organisms/${innerComp}/index`).then(module => ({
    default: module[innerComp] as ComponentType<unknown>,
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const buildCategoryItemProps = (item: any, innerComp: string, props?: any) => {
  const componentSpa = item?.[':type']?.split('/')[0];

  if (componentSpa === 'mi-aem-awp' && innerComp === 'CardCarouselContainer') {
    return withSearchCriteriaOnCarouselProps({
      model: { ...item },
      ...item,
      componentPath: props?.componentPath,
      ...(item?.[':items'] ? { cqItems: item[':items'] } : {}),
    });
  }
  return {
    model: { ...item },
    ...item,
    componentPath: props?.componentPath,
    allowedComponents: props?.allowedComponents,
    isAuthorMode: props?.isAuthorMode,
  };
};

export const useGetBreakpoint = (): string | undefined => {
  if (typeof window !== 'undefined' && window?.screen && window?.screen?.width) {
    return window.innerWidth > BREAKPOINT_DESKTOP
      ? 'desktop'
      : window.innerWidth > BREAKPOINT_TABLET
      ? 'tablet'
      : 'mobile';
  } else {
    return undefined;
  }
};
